import {
  IExternalEventSource,
  EventSourceOpenParametersType,
} from '@kameleoon/javascript-sdk-core/browser';

// --- Note ---
// Named `KameleoonEventSource` to avoid collision with native `EventSource`
export class KameleoonEventSource implements IExternalEventSource {
  private eventSource?: EventSource;

  public open({
    eventType,
    onEvent,
    url,
  }: EventSourceOpenParametersType): void {
    const eventSource = new EventSource(url);

    this.eventSource = eventSource;
    this.eventSource.addEventListener(eventType, onEvent);
  }

  public close(): void {
    if (this.eventSource) {
      this.eventSource.close();
    }
  }

  public onError(callback: (error: Event) => void): void {
    if (this.eventSource) {
      this.eventSource.onerror = callback;
    }
  }
}
